import React from "react";
import { useNavigate } from "react-router-dom";
import { IoMdArrowBack } from "react-icons/io";
import { FiTarget, FiGlobe, FiZap, FiShield, FiPackage } from "react-icons/fi";

const About = () => {
  const navigate = useNavigate();

  const values = [
    {
      icon: <FiZap size={18} />,
      title: "Speed",
      desc: "Fast, reliable logistics across Africa and beyond.",
    },
    {
      icon: <FiShield size={18} />,
      title: "Security",
      desc: "Ensuring your packages reach their destination safely.",
    },
    {
      icon: <FiPackage size={18} />,
      title: "Errands",
      desc: "From electronics delivery to personalized tasks, we get it done.",
    },
    {
      icon: <FiGlobe size={18} />,
      title: "Global",
      desc: "Connecting local sellers to international markets.",
    },
  ];

  return (
    <div className="min-h-screen bg-[#F8F9FA] flex flex-col relative overflow-hidden">
      {/* Decorative Blur */}
      <div className="absolute top-[-5%] right-[-10%] w-80 h-80 bg-orange-100 rounded-full blur-3xl opacity-40"></div>

      {/* Header */}
      <div className="bg-white px-6 py-6 flex items-center shadow-sm border-b border-gray-100 relative z-20">
        <button 
          onClick={() => navigate(-1)} 
          className="p-2 -ml-2 hover:bg-gray-100 rounded-full transition text-gray-900"
        >
          <IoMdArrowBack size={24} />
        </button>
        <div className="ml-4">
          <h1 className="text-[10px] font-black uppercase tracking-[0.2em] text-orange-600">Our Story</h1>
          <p className="text-xl font-black text-gray-900 tracking-tighter">About OurASAP</p>
        </div>
      </div>

      {/* Content Container */}
      <div className="flex-1 p-4 max-w-2xl mx-auto w-full relative z-10 pt-8 pb-20">
        <div className="bg-white rounded-[2.5rem] p-6 md:p-10 shadow-xl shadow-gray-200/50 border border-gray-100 space-y-12">
          
          {/* Main Mission Text */}
          <div className="space-y-6">
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 bg-orange-50 rounded-lg flex items-center justify-center text-orange-600">
                <FiTarget size={16} />
              </div>
              <h3 className="text-[11px] font-black uppercase tracking-widest text-gray-900">Our Mission</h3>
            </div>
            
            <div className="space-y-4 text-sm font-bold text-gray-600 leading-relaxed">
              <p>
                <span className="text-orange-600 font-black">OurASAP</span> is dedicated to providing fast, reliable, and convenient delivery and <span className="text-orange-600 font-black">errand services</span> across Africa and beyond. We connect buyers with nearby sellers and agents to ensure seamless fulfillment for all types of orders.
              </p>
              <p>
                Our mission is to simplify everyday tasks—ranging from <span className="text-gray-900 font-black">electronics procurement to personalized errand runs</span> empower local businesses, and make sure your packages reach their destination quickly and securely. With AI-powered logistics and real-time tracking, we keep you informed every step of the way.
              </p>
            </div>
          </div>

          {/* Core Values Grid */}
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
            {values.map((v, i) => (
              <div key={i} className="bg-gray-50 p-5 rounded-2xl border border-transparent hover:border-orange-200 transition-all group">
                <div className="text-orange-600 mb-3 group-hover:scale-110 transition-transform">
                  {v.icon}
                </div>
                <h4 className="text-[11px] font-black uppercase tracking-widest text-gray-900 mb-1">
                  {v.title}
                </h4>
                <p className="text-[10px] font-bold text-gray-500 leading-snug">
                  {v.desc}
                </p>
              </div>
            ))}
          </div>

          {/* Final Callout */}
          <div className="bg-gray-900 rounded-3xl p-8 text-center space-y-4">
            <h3 className="text-white text-lg font-black tracking-tighter">
              Ready to grow with us?
            </h3>
            <p className="text-gray-400 text-xs font-bold px-4">
              Whether you’re looking to deliver electronics, handle a personalized errand, or a seller aiming to reach more clients, OurASAP is your seamless platform.
            </p>
          </div>

          {/* Footer */}
          <p className="text-[10px] font-black text-gray-400 uppercase tracking-widest text-center pt-4">
            &copy; {new Date().getFullYear()} OurASAP. All rights reserved.
          </p>
        </div>
      </div>
    </div>
  );
};

export default About;